import {
  BUYING_ADMIN,
  BUYING_READONLY,
  BUYING_STANDARD,
  INSIGHTS_READONLY,
  REBALANCING_ADMIN,
  REBALANCING_READONLY,
  REBALANCING_STANDARD,
  REORDER_ADMIN,
  REORDER_READONLY,
  REORDER_STANDARD,
  REPLENISHMENT_ADMIN,
  REPLENISHMENT_READONLY,
  REPLENISHMENT_STANDARD,
} from '@autone/utils';

import {
  BulbIcon,
  BuyIcon,
  NewReorderIcon,
  NewReplenishmentIcon,
  RefreshIcon,
} from '../../../../icons';
import {
  BUYING_PATH_APP,
  INSIGHTS_PATH_APP,
  REBALANCING_PATH_APP,
  REORDER_PATH_APP,
  REPLEN_PATH_APP,
} from '../../routes';

import { type CreateSidebarItemParams } from './useAppSidebar.types';

/**
 * Static configuration for sidebar modules
 */
export const SIDEBAR_MODULES_CONFIG: Record<string, CreateSidebarItemParams> = {
  replenishment: {
    titleKey: 'sidenav.sections.modules.items.replenishment.name',
    path: REPLEN_PATH_APP.overview,
    icon: NewReplenishmentIcon,
    permissions: [
      REPLENISHMENT_READONLY,
      REPLENISHMENT_STANDARD,
      REPLENISHMENT_ADMIN,
    ],
  },
  reorder: {
    titleKey: 'sidenav.sections.modules.items.reorder.name',
    path: REORDER_PATH_APP.overview,
    icon: NewReorderIcon,
    permissions: [REORDER_READONLY, REORDER_STANDARD, REORDER_ADMIN],
  },
  rebalancing: {
    titleKey: 'sidenav.sections.modules.items.rebalancing.name',
    path: REBALANCING_PATH_APP.overview,
    icon: RefreshIcon,
    permissions: [
      REBALANCING_READONLY,
      REBALANCING_STANDARD,
      REBALANCING_ADMIN,
    ],
  },
  buying: {
    titleKey: 'sidenav.sections.modules.items.buying.name',
    path: BUYING_PATH_APP.overview,
    icon: BuyIcon,
    permissions: [BUYING_READONLY, BUYING_STANDARD, BUYING_ADMIN],
  },
  insights: {
    titleKey: 'sidenav.sections.modules.items.insights.name',
    // This item is a superset of all subitems therefore
    // even though /insights path doesn't exist, we need it in order
    // to identify when this item is active based on its sub-items
    path: INSIGHTS_PATH_APP.root.split('/').slice(0, 2).join('/'), // "/insights"
    icon: BulbIcon,
    permissions: [INSIGHTS_READONLY],
    subItems: [
      {
        titleKey: 'sidenav.sections.modules.items.insights.items.retail.name',
        path: INSIGHTS_PATH_APP.root,
      },
      {
        titleKey:
          'sidenav.sections.modules.items.insights.items.bestsellers.name',
        path: INSIGHTS_PATH_APP.bestsellers,
      },
      {
        titleKey: 'sidenav.sections.modules.items.insights.items.explorer.name',
        path: INSIGHTS_PATH_APP.explorer,
      },
    ],
  },
} as const;
